import {
	Grid,
	GridColumn,
	GridNoRecords,
} from "@tql/ui-components-react/kendo/grid";

import * as styles from "./shipment-tracking.module.css";

type TrackingUpdate = {
	readonly dateTime: string;
	readonly status: string;
	readonly location: string;
};

type ShipmentTrackingProps = {
	readonly trackingUpdates: readonly TrackingUpdate[];
	readonly distanceToNextStop?: string | null;
};

export function ShipmentTracking({
	trackingUpdates,
	distanceToNextStop,
}: ShipmentTrackingProps) {
	return (
		<div
			className={styles.shipmentTracking}
			data-testid={"shipment-tracking-section"}
		>
			<h2 className={styles.shipmentTrackingTitle}>Shipment Tracking</h2>
			{distanceToNextStop ? (
				<div
					className={styles.shipmentTrackingDistance}
					data-testid={"distance-to-next-stop"}
				>
					<span className={styles.shipmentTrackingDistanceLabel}>
						Distance to next stop:
					</span>
					<span className={styles.shipmentTrackingDistanceValue}>
						{distanceToNextStop}
					</span>
				</div>
			) : null}
			<div style={{ position: "relative" }}>
				<Grid
					data={[...(trackingUpdates ?? [])]}
					filterable={false}
					navigatable={false}
					scrollable={"scrollable"}
					selectable={false}
					sortable={false}
					style={{ maxHeight: "350px" }}
				>
					<GridNoRecords>
						<div className={styles.shipmentTrackingEmptyRow}>
							<span
								aria-hidden={true}
								className={styles.shipmentTrackingEmptyColumn}
							/>
							<span
								aria-hidden={true}
								className={styles.shipmentTrackingEmptyColumn}
							/>
							<span
								aria-hidden={true}
								className={styles.shipmentTrackingEmptyColumn}
							/>
							<div className={styles.shipmentTrackingEmptyMessage}>
								No records available
							</div>
						</div>
					</GridNoRecords>
					<GridColumn field={"dateTime"} title={"Date/Time(EST)"} width={125} />
					<GridColumn field={"location"} title={"Location"} width={125} />
					<GridColumn field={"status"} title={"Status"} />
				</Grid>
			</div>
		</div>
	);
}
